import cx from "classnames";
import { type FC, type ReactNode, useState } from "react";
import type { AccordionState } from "@/appInterface/windows/shapeToolSubMenu/utils";
import { ChevronUpIcon } from "@/icons";
import style from "./accordion.module.css";

type AccordionProps = {
    title: string;
    children: ReactNode;
    defaultExpanded?: boolean;
    className?: string;
    section: keyof AccordionState;
    onUpdateSection?: (section: keyof AccordionState, value: boolean) => void;
};

export const Accordion: FC<AccordionProps> = ({
    title,
    children,
    defaultExpanded = false,
    className,
    section,
    onUpdateSection,
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const toggleExpanded = () => {
        setIsExpanded((prev) => {
            const newState = !prev;
            onUpdateSection?.(section, newState);
            return newState;
        });
    };

    return (
        <div className={cx(style.accordion, className)}>
            <button
                className={style.header}
                onClick={toggleExpanded}
                type="button"
                aria-expanded={isExpanded}
            >
                <span className={style.title}>{title}</span>
                <span
                    className={cx(style.arrow, {
                        [style.arrowExpanded]: !isExpanded,
                    })}
                >
                    <ChevronUpIcon />
                </span>
            </button>
            <div
                className={cx(style.content, {
                    [style.contentExpanded]: isExpanded,
                })}
            >
                {children}
            </div>
        </div>
    );
};
